export default __webpack_public_path__ + "static/media/Flag_of_Qatar.fe7f90dd.svg";